import { withStyles, makeStyles } from '@material-ui/core/styles';
export const mainColor = "#0471B8"
